import { Component, inject, input, output, signal } from '@angular/core';
import { DsmAddendumService } from '../../../services/dsm-addendum.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { TaxAuthorityService, TaxCategoryDto, TaxRatesService } from '@zayan-erp/home-building';
import { FormsModule } from '@angular/forms';
import { DsmAddendumOptionTax } from '../../../models/dsm-addendum-state.models';
import { ButtonModule } from '@openng/optimus-ui/button';
import { SelectModule } from '@openng/optimus-ui/select';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
  standalone: true,
  selector: 'dsm-deal-tax-information',
  imports: [FormsModule, ButtonModule, SelectModule, TooltipModule],
  templateUrl: './dsm-deal-tax-information.component.html'
})
export class DsmDealTaxInformationComponent {
  #addendumService = inject(DsmAddendumService);
  #taxRateService = inject(TaxRatesService);
  #taxAuthorityService = inject(TaxAuthorityService);

  addendumProductId = input<string>('');
  addendumProductTaxes = input<DsmAddendumOptionTax[]>([]);
  category = input<TaxCategoryDto | null>(null);
  reload = output<void>();
  buyerAndBuilderApproved = input<boolean>(false);

  addAuthority = signal<boolean>(false);
  selectedAuthority = signal<string | null>(null);
  tempTaxRate = signal<any | null>(null);
  readonly savedVisible = signal(0);

  // if you wanted to call api for data you can use this and if you wanted to input data input signal is already created just send data
  // addendumProductTaxes = toSignal(this.#addendumService.readAddendumProductTaxes(this.addendumProductId()), {
  //   initialValue: []
  // });
  taxAuthorities = toSignal(this.#taxAuthorityService.readTaxAuthorities(), { initialValue: [] });
  addNewTaxAuthority() {
    if (this.selectedAuthority()) {
      this.#addendumService
        .createAddendumProductTax(
          {
            addendumProductId: this.addendumProductId(),
            taxAuthorityId: this.selectedAuthority()!
          },
          false
        )
        .subscribe({
          next: () => {
            this.savedVisible.update(n => n + 1);
            this.reload.emit();
            this.addAuthority.set(false);
            this.tempTaxRate.set(null);
            this.selectedAuthority.set(null);
          }
        });
    }
  }

  onAuthorityChange(authorityId: string | null): void {
    this.selectedAuthority.set(authorityId);
    this.getTaxRate();
  }

  getTaxRate() {
    if (this.selectedAuthority()) {
      this.#taxRateService.readTaxRates(this.selectedAuthority()!, this.category()?.id!, false).subscribe({
        next: taxRate => {
          ///this logic is used because most recent tax rate is applied also we need to avoid future tax because those are not implemented yet
          const now = new Date();
          const validTaxRates = taxRate
            .filter(rate => new Date(rate.effectiveDate) <= now)
            .sort((a, b) => new Date(b.effectiveDate).getTime() - new Date(a.effectiveDate).getTime());
          this.tempTaxRate.set(validTaxRates[0] || null);
          // Auto-save after fetching tax rate
          this.addNewTaxAuthority();
        }
      });
    }
  }
  deleteTaxAuthority(id: string) {
    this.#addendumService.deleteAddendumProductTax(this.addendumProductId(), id, false).subscribe({
      next: () => {
        this.savedVisible.update(n => n + 1);
        this.reload.emit();
      }
    });
  }
}
